import axios from "axios";
import { API_URL } from "src/scenes/App";

export type VisibilityFormType = "Surveys" | "Polls";

export interface VisibilityUser {
    uuid: string;
    employeeUuid: string;
    employeeName: string;
    firstName: string;
    lastName: string;
    isClient: boolean;
    profilePictureUrl: string;
    employmentPosition: string;
    department: string;
}

interface VisibilityUserResponse {
    employeeUuid: string;
    employeeName: string;
    firstName: string;
    lastName: string;
    isClient: boolean;
    profilePictureUrl: string;
    employmentPosition: string;
    department: string;
}

interface SurveyUsersResponse {
    companyEmployees: VisibilityUserResponse[];
}

interface PollParticipantsResponse {
    participants: VisibilityUserResponse[];
}

export async function getVisibilityUsers(
    token: string,
    formType: VisibilityFormType,
    signal: AbortSignal
): Promise<VisibilityUser[]> {
    const config = {
        headers: { Authorization: `Bearer ${token}` },
        signal
    };
    const users = formType === "Polls"
        ? (await axios.get<PollParticipantsResponse>(`${API_URL}/polls/participants`, config)).data.participants
        : (await axios.get<SurveyUsersResponse>(`${API_URL}/survey/company/getAllUsers`, config)).data.companyEmployees;

    return users.map(user => ({
        uuid: user.employeeUuid,
        ...user
    }));
}
